import { createGlobalStyle } from "styled-components";
import { palette, font } from "styled-theme";
import { colors } from "./constants";
import "antd/dist/antd.css";

const GlobalStyles = createGlobalStyle`
.item-type-block{
  padding:2px;
    text-align:center;
    padding-left:15px;
    padding-right:15px;
    font-size:12px;
    min-height:27px;
}
header .item-type-block{
  padding-top:5px;
}
  .gold{
    background: #D4AF37;
    background: linear-gradient(to bottom, #D4AF37 0%, #C5A028 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #D4AF37), color-stop(100%, #C5A028));
    background: -webkit-linear-gradient(top, #D4AF37 0%, #C5A028 100%);
    background: -moz-linear-gradient(top, #D4AF37 0%, #C5A028 100%);
    background: -o-linear-gradient(top, #D4AF37 0%, #C5A028 100%);
    background: -ms-linear-gradient(top, #D4AF37 0%, #C5A028 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#D4AF37', endColorstr='#C5A028', GradientType=0);
    border: 1px solid #B69119;
  }
  .silver{
    background: #C0C0C0;
    background: linear-gradient(to bottom, #C0C0C0 0%, #B1B1B1 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #C0C0C0), color-stop(100%, #B1B1B1));
    background: -webkit-linear-gradient(top, #C0C0C0 0%, #B1B1B1 100%);
    background: -moz-linear-gradient(top, #C0C0C0 0%, #B1B1B1 100%);
    background: -o-linear-gradient(top, #C0C0C0 0%, #B1B1B1 100%);
    background: -ms-linear-gradient(top, #C0C0C0 0%, #B1B1B1 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#C0C0C0', endColorstr='#B1B1B1', GradientType=0);
    border: 1px solid #A2A2A2;
  }
  .platinum, .palladium{
    color:#666666;
    background: #E5E4E2;
    background: linear-gradient(to bottom, #E5E4E2 0%, #D6D5D3 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #E5E4E2), color-stop(100%, #D6D5D3));
    background: -webkit-linear-gradient(top, #E5E4E2 0%, #D6D5D3 100%);
    background: -moz-linear-gradient(top, #E5E4E2 0%, #D6D5D3 100%);
    background: -o-linear-gradient(top, #E5E4E2 0%, #D6D5D3 100%);
    background: -ms-linear-gradient(top, #E5E4E2 0%, #D6D5D3 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#E5E4E2', endColorstr='#D6D5D3', GradientType=0);
    border: 1px solid #C7C6C4;
    box-shadow: inset 0 1px 0 #F4F3F1;
    -webkit-box-shadow: inset 0 1px 0 #F4F3F1;
    -moz-box-shadow: inset 0 1px 0 #F4F3F1;
  }

  .ant-btn-primary{
    background:${palette("primary", 0)} !important;
    border-color:${palette("primary", 0)} !important;
  }

  .ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab, .ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-tab{
    margin-right:0px !important;
  }
  
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .logo {
    font-size: 32px;
    font-weight: 700;
    color: #fff;
  }

  .ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td, .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td, .ant-table-thead > tr:hover:not(.ant-table-expanded-row) > td, .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
    background: #f8f8f8!important;
  }

  .ant-table-thead > tr > th, .ant-table-tbody > tr > td, .ant-table tfoot > tr > th, .ant-table tfoot > tr > td{
    padding: 12px 12px !important;
  }

  .ant-row.ant-form-item {
    margin-bottom: 5px;
  }

  .has-success.has-feedback {
    .ant-select {
      .ant-select-selection {
        .ant-select-selection__rendered {
          .ant-select-selection__placeholder {
            display: none !important;
          }
        }
      }
    }
  }

  /*-----------------------------------------------*/ 
  // style for project category menu [ScrumBoard]
  /*-----------------------------------------------*/
  .project-category {
    .ant-select-dropdown-menu {
      .ant-select-dropdown-menu-item {
        padding: 8px 12px;
        color: #000000;
        font-family: 'Roboto';
        font-weight: 400;
      }
    }
  }

  /*-----------------------------------------------*/ 
  // style for project menu [ScrumBoard]
  /*-----------------------------------------------*/
  .ant-dropdown {
    &.project-menu {
      width: 280px;
      top: 133px !important;
      
      .ant-dropdown-menu {
        padding: 0;
        overflow: hidden;

        .ant-dropdown-menu-item {
          min-height: 54px;
          line-height: auto;
          display: flex;
          align-items: center;
          padding: 10px 20px;

          &:first-child {
            padding: 0;
            border-bottom: 1px solid #f4f6fd;

            &:hover,
            &:focus {
              background-color: #ffffff;
            }
          }

          &:hover,
          &:focus {
            background-color: #F3F5FD;
          }

          &:last-child {
            background-color: #E6EAF8;
          }
        }
      }
    }
  }

  /*-----------------------------------------------*/ 
  // style for popover [ScrumBoard]
  /*-----------------------------------------------*/
  .ant-popover {
    .ant-checkbox-group {
      display: flex;
      flex-direction: column;
      .ant-checkbox-group-item {
        margin: 5px 0;
        span {
          font-size: 14px;
          color: #788195;
          text-transform: capitalize;
        }
      }
    }
  }

  /*-----------------------------------------------*/ 
  // style for modal [ScrumBoard]
  /*-----------------------------------------------*/
  .ant-modal-wrap {
    .ant-modal {
      .ant-modal-content {
        .ant-modal-body {
          .render-form-wrapper {
            padding: 10px;
            h2 {
              margin: 0;
            }
            form {
              padding: 15px 0 3px;
              .field-container {
                margin-bottom: 26px;
              }
            }
          }
        }
      }
    }
  }


/*-----------------------------------------------*/ 
  // style form previous GlobalStyles
  /*-----------------------------------------------*/

  .ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td, .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td, .ant-table-thead > tr:hover:not(.ant-table-expanded-row) > td, .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
    background: #f8f8f8!important;
}

font-family: ${font("primary", 0)};

h1,
h2,
h3,
h4,
h5,
h6,
a,
p,
li,
input,
textarea,
span,
div,
img,
svg {
  &::selection {
    background: ${palette("primary", 0)};
    color: #fff;
  }
}

.ant-row:not(.ant-form-item) {
  ${
    "" /* margin-left: -8px;
  margin-right: -8px; */
  };
  &:before,
  &:after {
    display: none;
  }
}

.ant-row > div {
  padding: 0;
}

.isoLeftRightComponent {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.isoCenterComponent {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.horizontal-form{
  display: flex;
}
.isoEditIcon{
  font-size: 1rem;
  svg{
    margin-left: .5rem;
    color: ${palette("primary", 0)};
  }
}
.isoEditDataWrapper{
  width: 60%;
  svg{
    margin-left: .5rem;
    color: #52c41a;
  }
}
`;

export default GlobalStyles;
